<div class="submission-state-container">
    <mat-icon class="icon {{this.state}}">circle</mat-icon>
    <p class="state-text">{{this.getState()}}</p>
</div>